import React from "react";

import { createStyles, Theme } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

const styles = (theme: Theme) => createStyles({
  root: {
    marginBottom: 30,
    marginTop: 30,
    width: '100%',
  },
});

function BB8SimpleTable(props: any) {
  const { classes } = props;

  return (
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
          {props.cols.map(({ title }: {title: string}, index: number) => (
            <TableCell key={`sub-table-header-cell-${index}`}>{title}</TableCell>
          ))}
          </TableRow>
        </TableHead>
        <TableBody>
        {props.data.map((row: any, i: number) => {
            return (
              <TableRow key={`sub-table-header-row-${i}`}>
                {props.cols.map(({ id }: {id: string}, index: number) => (
                  <TableCell key={`sub-table-header-cell-${index}-${i}`}>
                    {row[id]}
                  </TableCell>
                ))}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
  );
}

export default withStyles(styles)(BB8SimpleTable);